export class ChargeLineDTOModel {
    public period: string;
    public day1: number;
    public day2: number;
    public day3: number;
    public day4: number;
    public day5: number;
    public day6: number;
    public halfDay: number;
    public hr: number;
    public minCharge: number;
    public month: number;
    public same: number;
    public week: number;
    public weekend: number;

    [x: string]: any;
}
